export const getSDKSrc = ({
	site,
	siteId,
	cloudId,
	widgetId,
	locale,
}: {
	site: string;
	siteId?: string;
	cloudId?: string;
	widgetId?: string;
	locale?: string;
}): string => {
	const url = new URL(`/csm/widget/script.js`, `https://${site}`);

	if (siteId) {
		url.searchParams.set('siteId', siteId);
		url.searchParams.set('site', site);
	}

	if (cloudId) {
		url.searchParams.set('cloudId', cloudId);
		url.searchParams.set('site', site);
	}

	if (widgetId) {
		url.searchParams.set('widgetId', widgetId);
	}

	if (locale) {
		url.searchParams.set('locale', locale);
	}

	return url.toString();
};
